import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getLoginVerifyPasswordPath = () => {
  return urlHelper('/auth/verify-password');
};
